import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const TopicTagDetailNavigationHeaderRight = React.memo(() => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();

  const onViewAllTags = useCallback(() => {
    router.push('/tags');
  }, [router]);

  const label = t('nav.routes.topicTags.viewAllTags');

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="tag"
        label={isXS ? undefined : label}
        tooltip={t('nav.routes.topicTags.viewAllTagsTitle')}
        accessibilityLabel={label}
        onPress={onViewAllTags}
      />
    </NavigationBarButtonContainer>
  );
});

TopicTagDetailNavigationHeaderRight.displayName = 'TopicTagDetailNavigationHeaderRight';

export function getTopicTagDetailRouteNavigationOptions(title) {
  return {
    title,
    headerTitle: title,
    headerBackVisible: true,
    headerRight: () => <TopicTagDetailNavigationHeaderRight />,
  };
}

export default getTopicTagDetailRouteNavigationOptions;
